function parse_json_string(value, fallback = {}) {
  try { return JSON.parse(value); }
  catch { return fallback; }
}

export function parse_response_payload(value) {
  if (typeof value !== 'string') return value || {};
  return parse_json_string(value, { message: value });
}

export function response_message(error) {
  const payload = parse_response_payload(error?.response?.data);
  return String(
    payload?.message
    || payload?.detail
    || payload?.error
    || error?.message
    || ''
  );
}

export function response_session_expiry_time(response_data = {}, default_timeout_minutes = 0) {
  const expires_at = response_data.expires_at
    || response_data.token_expires_at
    || response_data.session_expires_at;
  const expires_in = Number(response_data.expires_in || response_data.expires_in_seconds || 0);

  if (expires_at) {
    return new Date(expires_at).getTime();
  }

  if (expires_in > 0) {
    return Date.now() + expires_in * 1000;
  }

  if (default_timeout_minutes > 0) {
    return Date.now() + default_timeout_minutes * 60 * 1000;
  }

  return 0;
}
